package com.hyperether.goodjob

import App
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import androidx.navigation.ExperimentalBrowserHistoryApi
import androidx.navigation.NavHostController
import androidx.navigation.bindToBrowserNavigation
import androidx.navigation.compose.rememberNavController
import com.hyperether.goodjob.com.hyperether.goodjob.util.FileUtilJsMain
import com.hyperether.goodjob.database.DriverFactory
import com.hyperether.goodjob.database.SharedDatabase
import com.hyperether.goodjob.managers.FileManager
import com.hyperether.goodjob.managers.NetworkManager
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.navigation.Dashboard
import com.hyperether.goodjob.navigation.Landing
import com.hyperether.goodjob.navigation.Pricing
import com.hyperether.goodjob.navigation.Register
import com.hyperether.goodjob.navigation.RouteScreen
import com.hyperether.goodjob.navigation.Routes
import com.hyperether.goodjob.navigation.SettingsWeb
import com.hyperether.goodjob.navigation.Workspace
import com.hyperether.goodjob.repository.prefs.Preferences
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.repository.remote.ApiConfig
import com.hyperether.goodjob.repository.remote.ClientProvider
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.file_added
import com.hyperether.goodjob.resources.files_skipped_message
import com.hyperether.goodjob.resources.files_skipped_title
import com.hyperether.goodjob.resources.join_good_job
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.password_set
import com.hyperether.goodjob.resources.password_updated
import com.hyperether.goodjob.resources.set_new_password
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.PopUpDialogNested
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.scenes.register.SetPasswordWebView
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.NavigationUtil
import com.hyperether.goodjob.util.URLManager
import com.hyperether.goodjob.util.UploadManager
import com.hyperether.goodjob.util.isMouseOverMap
import com.hyperether.goodjob.util.isSignature
import com.hyperether.resources.AppLocale
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import org.hyperether.auth.apple.AppleSignInResultHandler
import org.hyperether.auth.google.GoogleSignInResultHandler
import org.jetbrains.skiko.wasm.onWasmReady
import org.lighthousegames.logging.logging
import org.w3c.dom.Element
import org.w3c.dom.events.Event
import org.w3c.dom.url.URLSearchParams
import web.navigator.navigator
import kotlin.time.DurationUnit
import kotlin.time.toDuration


private lateinit var prefsManager: PrefsManager
lateinit var commonModule: CommonModule
private lateinit var navController: NavHostController

private lateinit var navigateFun: (route: RouteScreen) -> Unit
private var _jobId: MutableState<String?> = mutableStateOf(null)
var userCheckTimestamp: Instant = Clock.System.now()

@OptIn(ExperimentalComposeUiApi::class, ExperimentalBrowserHistoryApi::class)
fun main() {
    // Check if we're returning from a zoom refresh and restore the hash before init
    val savedTarget = localStorage.getItem("zoom_refresh_target")
    if (savedTarget != null && window.location.hash.isEmpty()) {
        localStorage.removeItem("zoom_refresh_target")
        // Set the hash before anything else initializes
        window.location.hash = savedTarget
    }

    val sharedDatabase = SharedDatabase(DriverFactory())
    val queryParams = URLSearchParams(document.location?.search ?: "")
    //todo check if hash is for register or forgot password
    var url = window.location.href
    var hash = queryParams.get("hash")
    var wid = queryParams.get("wid")

    prefsManager = PrefsManager(Preferences())
    ClientProvider.initialize(prefsManager) {
        commonModule.logout {}
        navController.navigate(Landing) {
            popUpTo(0) {
                inclusive = true
            }
            launchSingleTop = true
        }
    }
    val fileManager = FileManager()
    GoogleSignInResultHandler.handleRedirect()
    AppleSignInResultHandler.handleRedirect()

    val networkManager = NetworkManager()
    commonModule = CommonModule(
        prefsManager,
        networkManager,
        fileManager,
        sharedDatabase,
        CommonModule.Platform.WEB,
        mutableStateOf(getCurrentRoute())
    )

    val log = logging("WEB MAIN")
    val language = prefsManager.getLanguage()
    if (language == "de") {
        currentLanguage.value = AppLocale.DE
    } else {
        currentLanguage.value = AppLocale.DEFAULT
    }

    onWasmReady {
        ComposeViewport(viewportContainerId = "composeApplication") {
            println("WEB APP version 1.2.5")
            log.d("NAV") { "language: ${currentLanguage.value} saved: ${prefsManager.getLanguage()}" }
            navController = rememberNavController()
            commonModule.navHostController = navController

            // Enable browser navigation integration
            LaunchedEffect(navController) {
                navController.bindToBrowserNavigation()
            }

            App(
                navController = navController,
                commonModule = commonModule,
                onChoosePlanClick = { amount, currency ->
                    localStorage.setItem("amount", amount.toString())
                    localStorage.setItem("currency", currency)

                    // Set payment language based on current app language
                    val currentLang = if (currentLanguage.value == AppLocale.DE) "de" else "en"
                    setPaymentLanguage(currentLang)

                    commonModule.onChoosePlan(
                        amount,
                        onSuccess = { paymentInfo ->
                            localStorage.setItem("client_secret", paymentInfo.clientSecret)
                            localStorage.setItem("ephemeral_key", paymentInfo.ephemeralKey)
                            println("Storing amount in localStorage: $amount")
                            runStripe(
                                ApiConfig.baseURL, amount.toString(), currency
                            )
                        },
                        onUserLogin = {
                            navController.navigate(Workspace) {
                                popUpTo(Register) {
                                    inclusive = true
                                }
                            }
                        })
                },
                onLogout = {
                    logout(navigateFun)
                },
                onUploadDocumentClick = { jobId, documentType ->
                    _jobId.value = jobId
                    uploadSelectedFile(documentType)
                },
                onOpenPdf = { filePath ->
                    window.open(filePath, "_blank")
                },
                currentRoute = getCurrentRoute(),
                onDestinationChanged = { destination ->
                    // Check user every 10 seconds
                    Clock.System.now().let {
                        if (it.minus(userCheckTimestamp).inWholeSeconds > 10.toDuration(DurationUnit.SECONDS).inWholeSeconds) {
                            log.d("NAV") { "User check for inactivity" }
                            userCheckTimestamp = it
                            logoutIfUserIsInactive()
                        } else {
                            log.d("NAV") { "No need to check user inactivity" }
                        }
                    }
                }
            )
            LaunchedEffect(url) {
                handleDeepLink(
                    uri = url,
                    hash = hash,
                    wid = wid,
                    path = getRouteFromHash(),
                    prefsManager = prefsManager,
                    clearHash = { hash = null },
                    navigate = { route ->
                        navController.navigate(route)
                    })
            }

            LaunchedEffect(Unit) {
                if (window.location.href.contains("redirect_status")) {
                    commonModule.pricingViewModel.showLoader.value = true
                }
            }

            LaunchedEffect(Unit) {
                window.asDynamic().onPaymentSuccess = {
                    println("onPaymentSuccess called from JS")
                    MainScope().launch {
                        commonModule.onPayment()
                    }
                    localStorage.removeItem("payment_success")
                }

                val paymentSuccess = localStorage.getItem("payment_success")
                if (paymentSuccess == "true") {
                    println("PayPal flow succeeded, calling onPaymentSuccess from Kotlin")
                    localStorage.removeItem("payment_success")
                    (window.asDynamic().onPaymentSuccess as? () -> Unit)?.invoke()
                }
            }

            // Zoom detection for canvas refresh
            LaunchedEffect(Unit) {
                setupZoomDetection()
            }

            PopupsContainer(
                commonModule = commonModule
            )
        }
    }
}

@Composable
private fun PopupsContainer(
    commonModule: CommonModule
) {
    if (commonModule.showSetPasswordView.value) {
        SetPasswordWebView(
            title = stringResource(Res.string.join_good_job),
            passwordInput = commonModule.passwordInput,
            confirmPasswordInput = commonModule.confirmPasswordInput,
            onSavePassword = {
                CoroutineScope(Dispatchers.Main).launch {
                    commonModule.setPassword()
                }
            })
    }

    if (commonModule.showSetNewPasswordView.value) {
        SetPasswordWebView(
            title = stringResource(Res.string.set_new_password),
            passwordInput = commonModule.passwordInput,
            confirmPasswordInput = commonModule.confirmPasswordInput,
            onSavePassword = {
                CoroutineScope(Dispatchers.Main).launch {
                    commonModule.resetPassword()
                }
            })
    }

    if (commonModule.showPlanChangedDialog.value) {
        commonModule.pricingViewModel.showLoader.value = false
        PopUpDialog(
            onDismiss = {
//                        commonModule.showPlanChangedDialog.value = false
//                        localStorage.setItem("client_secret", "")
            },
            title = stringResource(Res.string.success).uppercase(),
            message = commonModule.pricingViewModel.getPlanChangeMessage(),
            onPositiveBtnClicked = {
                if (commonModule.pricingViewModel.isNavigationSourceDrawer.value || getCurrentRoute() == SettingsWeb) {
                    navController.navigate(Dashboard)
                } else {
                    navController.navigate(Workspace)
                }
                commonModule.showPlanChangedDialog.value = false
                localStorage.setItem("client_secret", "")
                commonModule.pricingViewModel.messageTextChangePlan.value = ""
            },
            positiveBtnText = stringResource(Res.string.ok).uppercase()
        )
    }

    if (commonModule.showMaxSizeDialog.value) {
        PopUpDialogNested(
            onDismiss = {
                commonModule.showMaxSizeDialog.value = false
            },
            title = stringResource(Res.string.files_skipped_title),
            message = stringResource(Res.string.files_skipped_message),
            onPositiveBtnClicked = {
                commonModule.showMaxSizeDialog.value = false
            },
            positiveBtnText = stringResource(Res.string.ok).uppercase()
        )
    }

    if (commonModule.showFileAddedSuccess.value) {
        PopUpDialogNested(
            onDismiss = {
                commonModule.showFileAddedSuccess.value = false
            },
            title = stringResource(Res.string.success).uppercase(),
            message = stringResource(Res.string.file_added),
            onPositiveBtnClicked = {
                commonModule.showFileAddedSuccess.value = false
            },
            positiveBtnText = stringResource(Res.string.ok).uppercase()
        )
    }

    if (commonModule.showPasswordSetSuccessDialog.value) {
        PopUpDialog(
            onDismiss = {
                commonModule.showPasswordSetSuccessDialog.value = false
                if (navigator.userAgent.contains("iPhone") || navigator.userAgent.contains(
                        "iPad"
                    )
                ) {
                    //todo set it when it is published
                    //todo check if just go to ios app it will contain hash in url
                    window.location.href =
                        "https://apps.apple.com/app/id123456789?referrer=12345"
                } else {
                    updateUrlToRegisterScreen()
                }
            },
            title = stringResource(Res.string.success).uppercase(),
            message = stringResource(Res.string.password_set),
            onPositiveBtnClicked = {
                commonModule.showPasswordSetSuccessDialog.value = false
                updateUrlToRegisterScreen()
            },
            positiveBtnText = stringResource(Res.string.ok).uppercase()
        )
    }

    if (commonModule.showPasswordUpdatedSuccessDialog.value) {
        PopUpDialog(
            onDismiss = {
                commonModule.showPasswordUpdatedSuccessDialog.value = false
                updateUrlToRegisterScreen()
            },
            title = stringResource(Res.string.success).uppercase(),
            message = stringResource(Res.string.password_updated),
            onPositiveBtnClicked = {
                commonModule.showPasswordUpdatedSuccessDialog.value = false
                updateUrlToRegisterScreen()
            },
            positiveBtnText = stringResource(Res.string.ok).uppercase()
        )
    }

    if (commonModule.showPasswordErrorDialog.value) {
        ErrorDialog(
            onDismiss = {
                commonModule.showPasswordErrorDialog.value = false
                updateUrlToRegisterScreen()
            },
            title = stringResource(Res.string.error).uppercase(),
            message = commonModule.errorText.value
        )
    }

    if (commonModule.showErrorDialog.value) {
        ErrorDialog(
            onDismiss = { commonModule.showErrorDialog.value = false },
            title = stringResource(Res.string.error).uppercase(),
            message = commonModule.errorText.value
        )
    }

    if (commonModule.pricingViewModel.showLoader.value) {
        println("route tracking: showLoader")
        FullScreenProgressBar()
    }

    if (commonModule.showLoader.value) {
        FullScreenProgressBar()
    }
}

private fun logoutIfUserIsInactive() {
    commonModule.repository.getUser()?._id?.let {
        println("logoutIfUserIsInactive check for $it")
        MainScope().launch {
            val userResource = commonModule.repository.getUserById(it)
            if (userResource.data == null) {
                println("logoutIfUserIsInactive deleted, logout")
                logout(navigateFun)
            }
        }
    }
}

fun getCurrentRoute(): RouteScreen {
    val route = getRouteFromHash()
    var currentRoute: RouteScreen
    if (route.isNotEmpty()) {
        currentRoute = Routes.findByRoute(route)
    } else {
        // paypal contains this in path
        if (window.location.href.contains("redirect_status")) {
            println("route tracking: redirecting to pricing")
            currentRoute = Pricing
        } else {
            currentRoute = Landing
        }
    }
    println("route tracking: getCurrentRoute find from: $route")
    println("route tracking: getCurrentRoute find: $currentRoute")
    return currentRoute
}

fun updateUrlToRegisterScreen() {
    window.location.href = "/#register"
}

fun handleDeepLink(
    uri: String,
    hash: String?,
    wid: String?,
    path: String,
    prefsManager: PrefsManager,
    clearHash: () -> Unit,
    navigate: (route: RouteScreen) -> Unit
) {
    navigateFun = navigate
    CoroutineScope(Dispatchers.Default).launch {
        if (wid == null) {
            commonModule.token.value = if (uri.contains("token=")) {
                log.d("handleDeepLink") { "token: ${commonModule.token.value} uri: $uri" }
                uri.substringAfter("token=", "").substringBefore("&")
            } else {
                null
            }
            if (!commonModule.token.value.isNullOrEmpty() && uri.contains("reset-password")) {
                URLManager.extractEmailFromUrl(uri)?.let {
                    commonModule.repository.saveEmail(it)
                }
                commonModule.showSetNewPasswordView.value = true
            } else {
                hash?.let { hash ->
                    if (navigator.userAgent.contains("Android")) {
                        window.location.href =
                            "https://play.google.com/store/apps/details?id=com.hyperether.goodjob&referrer=${path}hash$hash"
                        return@launch
                    }
//            else if (navigator.userAgent.contains("iPhone") || navigator.userAgent.contains("iPad")) {
//                //todo finish for ios
//                window.location.href = "https://apps.apple.com/app/id123456789?referrer=12345"
//                return@launch
//            }
                    delay(1000L)
                    log.d("handleDeepLink") { "token: ${commonModule.token.value} uri: $uri, hash: $hash" }

                    if (uri.contains("set-password")) {
                        log.d { "set-password logout" }
                        commonModule.repository.logoutUser()
                        commonModule.setPasswordHash.value = hash
                        commonModule.showSetPasswordView.value = true
                    }
                    if (uri.contains("confirm-registration")) {
                        log.d { "confirm-registration logout" }
                        commonModule.repository.logoutUser()
                        val result = commonModule.repository.confirmation(hash)
                        if (result is Resource.Success) {
                            clearHash()
                            handleNavigation(prefsManager, navigate)
                        } else {
                            result.text?.let {
                                commonModule.errorText.value = it
                                commonModule.showErrorDialog.value = true
                            }
                        }
                    }
                } ?: run {
                    delay(1000L)
                    log.d("handleDeepLink") { "HASH empty" }
                    handleNavigation(prefsManager, navigate)
                }
            }
        } else {
            prefsManager.setWidQuery(wid)
            prefsManager.getUser()?.let {
                it.role?.let { role ->
                    if (role.equals(Role.superAdmin.name, ignoreCase = true)) {
                        navigate(Workspace)
                    }
                }
            }
        }
    }
}

private fun logout(navigate: (route: RouteScreen) -> Unit) {
    commonModule.logout {
        navigate(Register)
    }
}

private fun getRouteFromHash(): String {
    val location = window.location.href
    val hash = window.location.hash
    val route = hash
        .removePrefix("#")
        .substringBefore("?")
        .trim()
    println("route tracking: Current route location is $location")
    println("route tracking: Current route is $route")
    return route
}

private val PublicScreens: Set<RouteScreen> = setOf(Landing, Register, Pricing)
fun handleNavigation(
    prefsManager: PrefsManager,
    navigate: (RouteScreen) -> Unit,
    getToken: () -> String = { commonModule.repository.getToken() }
) {
    val currentPath = getRouteFromHash()
    val matchedRoute = Routes.findByRoute(currentPath)
    println("route tracking: matchedRoute route is $matchedRoute")
    if (getToken().isEmpty() && (matchedRoute !in PublicScreens)) {
        println("route tracking: Navigate landing, it is not in public routes")
        navigate(Landing)
        return
    }

//    if (currentPath.contains("details", ignoreCase = true)) {
//        println("route tracking: Checking if contains details")
//        val target: RouteScreen = when {
//            currentPath.contains("employee_details", ignoreCase = true) -> Users
//            currentPath.contains("contact_details", ignoreCase = true) -> Contacts
//            currentPath.contains("job_details", ignoreCase = true) -> Jobs
//            else -> Dashboard
//        }
//        navigate(target)
//        return
//    }

    if (currentPath.equals("add_new", ignoreCase = true)) {
        navigate(Dashboard)
        return
    }

    if (matchedRoute != null) {
        navigate(matchedRoute)
        return
    }

    val onboardingScreen = NavigationUtil.getOnboardingScreen(prefsManager, false)

    navigate(onboardingScreen)
}

fun uploadSelectedFile(
    documentType: DocumentType? = null
) {
    FileUtilJsMain().openFilePicker(
        isSignature = documentType.isSignature(),
        multiple = !documentType.isSignature()
    ) { files ->
        // If no files selected (user cancelled), invoke callback immediately
        if (files.isEmpty()) {
            log.d("uploadSelectedFile") { "File picker cancelled by user" }
            return@openFilePicker
        }
        commonModule.showLoader.value = true

        var filesProcessed = 0
        val totalFiles = files.size
        var hasLargeFile = false

        files.forEach { file ->
            val maxSize = 10 * 1024 * 1024 // 10MB

            if (file.size.toFloat() > maxSize) {
                log.d("uploadSelectedFile") { "File ${file.name} skipped: larger than 10MB (${file.size} bytes)" }
                filesProcessed++
                if (filesProcessed == totalFiles) {
                    commonModule.showLoader.value = false
                }
                hasLargeFile = true
                if (file == files.last()) {
                    if (hasLargeFile) {
                        commonModule.showMaxSizeDialog.value = true
                        hasLargeFile = false
                    }
                }
                return@forEach
            }

            FileUtilJsMain().readFileAsByteArray(file) { byteArray ->
                val fileId = file.name
                val fileType = file.type

                when {
                    fileType.startsWith("image/") -> {
                        log.d("uploadSelectedFile") { "Image File Name: $fileId Bytes: ${byteArray.size} bytes" }
                        val docType =
                            when (documentType) {
                                DocumentType.JOB_FILE -> DocumentType.JOB_IMAGE
                                DocumentType.REPORT_FILE -> DocumentType.REPORT_FILE_IMAGE
                                else -> DocumentType.REPORT_SIGNATURE_IMAGE
                            }
                        UploadManager.updateFile(
                            fileId,
                            byteArray,
                            docType,
                            commonModule.repository,
                            showLoader = null,
                            _jobId.value,
                            onComplete = {
                                filesProcessed++
                                if (filesProcessed == totalFiles) {
                                    commonModule.showLoader.value = false
                                    commonModule.showFileAddedSuccess.value = true
                                }
                            },
                            onError = {
                                commonModule.errorText.value = it
                                commonModule.showErrorDialog.value = true
                            }
                        )
                    }

                    fileType == "application/pdf" -> {
                        log.d("uploadSelectedFile") { "PDF File Name: $fileId Bytes: ${byteArray.size} byte" }
                        val docType =
                            when (documentType) {
                                DocumentType.JOB_FILE -> DocumentType.JOB_PDF
                                DocumentType.REPORT_FILE -> DocumentType.REPORT_FILE_PDF
                                else -> DocumentType.REPORT_SIGNATURE_PDF
                            }
                        UploadManager.updateFile(
                            fileId,
                            byteArray,
                            docType,
                            commonModule.repository,
                            showLoader = null,
                            _jobId.value,
                            onComplete = {
                                filesProcessed++
                                if (filesProcessed == totalFiles) {
                                    commonModule.showLoader.value = false
                                    commonModule.showFileAddedSuccess.value = true
                                }
                            },
                            onError = {
                                commonModule.showLoader.value = false
                                commonModule.errorText.value = it
                                commonModule.showErrorDialog.value = true
                            }
                        )
                    }

                    else -> {
                        log.d("uploadSelectedFile") { "Unsupported file type: $fileType" }
                        filesProcessed++
                        if (filesProcessed == totalFiles) {
                            commonModule.showLoader.value = false
                        }
                    }
                }
            }
            if (file == files.last()) {
                if (hasLargeFile) {
                    commonModule.showLoader.value = false
                    commonModule.showMaxSizeDialog.value = true
                    hasLargeFile = false
                }
            }
        }
    }
}

@JsName("runStripe")
external fun runStripe(baseUrl: String, amount: String, currency: String)

@JsName("setPaymentLanguage")
external fun setPaymentLanguage(language: String)

// Flag to ensure zoom detection is only set up once
private var zoomDetectionInitialized = false

fun setupZoomDetection() {
    if (zoomDetectionInitialized) {
        return // Already initialized, don't add duplicate listeners
    }
    zoomDetectionInitialized = true

    var lastDevicePixelRatio = window.devicePixelRatio
    var refreshTimeoutId: Int? = null

    val log = logging("ZOOM_DETECTION")

    // Periodically check for map element and attach listeners
    fun attachMapListeners() {
        val appElement = document.getElementById("composeApplication")
        val mapElement = appElement?.shadowRoot?.getElementById("mapid")

        if (mapElement != null && !mapElement.asDynamic().hasZoomListeners) {
            log.d { "Map element found, attaching mouse listeners" }

            mapElement.addEventListener("mouseenter", {
                isMouseOverMap = true
                log.d { "Mouse entered map area" }
            })

            mapElement.addEventListener("mouseleave", {
                isMouseOverMap = false
                log.d { "Mouse left map area" }
            })

            // Mark that we've attached listeners to this element
            mapElement.asDynamic().hasZoomListeners = true
        }
    }

    // Initial attempt to attach listeners
    attachMapListeners()

    // Retry periodically in case map loads later
    val retryInterval = window.setInterval({
        attachMapListeners()
    }, 1000)

    fun refreshCanvas() {
        if (isMouseOverMap) {
            log.d { "Browser zoom detected but cursor is on map - skipping refresh" }
            return
        }

        log.d { "Browser zoom detected, refreshing canvas..." }

        // Clear any existing timeout
        refreshTimeoutId?.let { window.clearTimeout(it) }

        // Save current hash (navigation state) to localStorage
        val currentHash = window.location.hash
        log.d { "Saving current navigation state: $currentHash" }

        if (currentHash.isNotEmpty()) {
            localStorage.setItem("zoom_refresh_target", currentHash)
        }

        // Navigate to root and reload
        window.location.href = window.location.origin + "/"
    }

    // Monitor device pixel ratio changes (zoom detection)
    fun checkForZoom() {
        val currentRatio = window.devicePixelRatio
        if (kotlin.math.abs(currentRatio - lastDevicePixelRatio) > 0.001) {
            log.d { "Device pixel ratio changed from $lastDevicePixelRatio to $currentRatio" }
            lastDevicePixelRatio = currentRatio

            // Debounce the refresh to avoid multiple rapid calls
            refreshTimeoutId?.let { window.clearTimeout(it) }
            refreshTimeoutId = window.setTimeout({
                refreshCanvas()
            }, 10)
        }
    }

    // Listen for zoom via keyboard shortcuts (Ctrl/Cmd + +/-/0)
    val keydownListener: (Event) -> Unit = { event ->
        val keyboardEvent = event.asDynamic()
        if ((keyboardEvent.ctrlKey == true || keyboardEvent.metaKey == true) && (keyboardEvent.key == "+" || keyboardEvent.key == "-" || keyboardEvent.key == "0")) {
            log.d { "Keyboard zoom shortcut detected" }

            refreshTimeoutId?.let { window.clearTimeout(it) }
            refreshTimeoutId = window.setTimeout({
                refreshCanvas()
            }, 200)
        }
    }
    window.addEventListener("keydown", keydownListener)

    // Listen for zoom via mouse wheel + Ctrl/Cmd
    val wheelListener: (Event) -> Unit = { event ->
        val wheelEvent = event.asDynamic()
        val target = event.target as? Element

        // Check if the target is inside the excluded div (by ID or class)
        val isOverExcludedDiv = target?.closest("#mapid") != null
        // OR for class: target?.closest(".excluded-class") != null

        if (!isOverExcludedDiv && (wheelEvent.ctrlKey == true || wheelEvent.metaKey == true)) {
            log.d { "Mouse wheel zoom detected" }

            refreshTimeoutId?.let { window.clearTimeout(it) }
            refreshTimeoutId = window.setTimeout({
                refreshCanvas()
            }, 200)
        }
    }
    window.addEventListener("wheel", wheelListener)

    // Periodically check for device pixel ratio changes
    window.setInterval({
        checkForZoom()
    }, 200)

    log.d { "Zoom detection initialized with map exclusion" }
}